export default function InitialValues() {
  return {
    document: null,
    name: '',
    type: ''
  };
}
